import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ListadoEmpleos from './ListadoEmpleos';
import DetalleEmpleo from './DetalleEmpleo';
import EnviarOferta from './EnviarOferta';
import Info from "./Info";
import Login from "./Login";

function App() {
  return (
    <Routes>
      <Route path="/" element={<ListadoEmpleos />} />
      <Route path="/empleo/:id" element={<DetalleEmpleo />} />
      <Route path="/enviar" element={<EnviarOferta />} />
      <Route path="/info" element={<Info />} />
      <Route path="/login" element={<Login />} />
    </Routes>
  );
}

export default App;
